"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagAtom = tagAtom;
const getXAtomicNumber_1 = require("./getXAtomicNumber");
/**
 * Tag an atom to be able to visualize it
 */
function tagAtom(molecule, iAtom) {
    const customLabel = `${molecule.getAtomLabel(iAtom)}*`;
    molecule.setAtomCustomLabel(iAtom, customLabel);
    if (molecule.getAtomicNo(iAtom) === 1) {
        molecule.setAtomicNo(iAtom, (0, getXAtomicNumber_1.getXAtomicNumber)(molecule));
    }
    else {
        // we can not use X because we would have problems with valencies if it is
        // expanded hydrogens or not
        // we can not only use a custom label because it does not count for the canonisation
        molecule.setAtomMass(iAtom, molecule.getAtomMass(iAtom) + 5);
    }
    return customLabel;
}
//# sourceMappingURL=tagAtom.js.map